module.exports = "/images/side-support.svg?8fc1b87c4666bc22e150f358cc6eae87";